/**
 * R4: Broken relation cleanup [AUTO-APPLY, confidence=1.0]
 *
 * Broken relation = relacja gdzie from_node_id lub to_node_id nie istnieje w mapie
 * (NULL lub node w innej mapie). Przykład: po ręcznym DELETE noda bez cascade,
 * albo po niekompletnym merge w którymś z poprzednich runów.
 *
 * Pure function: IN = {relations[], nodes[]} — znajduje relacje do usunięcia.
 */

import type {
  RepairRuleInput,
  RepairRuleResult,
  BrokenRelationRef,
} from "@/types/mapRepair";

export function runR4(input: RepairRuleInput): RepairRuleResult {
  const nodeIds = new Set(input.nodes.map((n) => n.id));
  const broken: BrokenRelationRef[] = [];

  for (const r of input.relations) {
    const fromValid = nodeIds.has(r.from_node_id);
    const toValid = nodeIds.has(r.to_node_id);
    if (!fromValid || !toValid) {
      broken.push({
        id: r.id,
        from_node_id: r.from_node_id,
        to_node_id: r.to_node_id,
      });
    }
  }

  const operations: RepairRuleResult["operations"] = [];
  if (broken.length > 0) {
    operations.push({
      operation: "delete",
      payload: {
        rule: "R4",
        deleted_count: broken.length,
        relation_ids: broken.map((b) => b.id),
        sample: broken.slice(0, 50),
      },
      rollback_payload: {
        deleted_relations: input.relations
          .filter((r) => broken.find((b) => b.id === r.id))
          .map((r) => ({ ...r })),
      },
    });
  }

  return {
    rule: "R4",
    operations,
    proposals: [],
    flags: [],
    skipped: [],
  };
}
